import { internal, template, FormElementMixin, WrappedStandardElement } from '../../vendor/elix.js';

import EmptyValueMixin from '../mixins/empty-value-mixin.js';
import FormValueMixin from '../mixins/form-value-mixin.js';

const downArrow = (fill, transform = '') => `
<svg xmlns="http://www.w3.org/2000/svg" transform="${transform}" width="10" height="5" viewBox="0 0 10 5" fill="${fill}">
  <path d="M 0 0 l5 5 5 -5 z"/>
</svg>`;

const upArrow = (fill) => downArrow(fill, 'scale(1, -1)')

class TpSelectNativeBase extends
  EmptyValueMixin(
  FormValueMixin(
  FormElementMixin(
  WrappedStandardElement.wrap(
    'select'
  )))) {

  connectedCallback() {
    this.options = this.querySelectorAll('option');
    this.value = this.value || this.getAttribute('value');
    super.connectedCallback();
  }

  get [internal.defaultState]() {
    return Object.assign(
      {},
      super[internal.defaultState],
      { options: [] }
    );
  }

  get value() {
    const selectedOption = this.selectedOption;
    return selectedOption ? selectedOption.value : undefined;
  }

  set value(value) {
    this.options.forEach((option) => {
      option.selected = option.value === value || option.text === value;
    });
    this[internal.setState]({ value: this.value });
  }

  get options() {
    return Array.from(this[internal.state].options);
  }

  set options(options) {
    this[internal.setState]({ options });
  }

  get selectedIndex() {
    return this.options.findIndex(option => option.selected);
  }

  get selectedOption() {
    return Array.from(this.options).find(option => option.selected);
  }

  [internal.render](changed) {
    super[internal.render](changed);

    const inner = this[internal.ids].inner;

    if (changed.options) {
      inner.innerHTML = '';
      this.options.forEach(option => inner.appendChild(option));
    }

    inner.selectedIndex = this.selectedIndex;
  }

  get [internal.template]() {

    return template.concat(

     super[internal.template],

      template.html`
       
        <style>

          :host {
            position: relative;
          }

          #inner {
            background-image: url("data:image/svg+xml;charset=UTF-8,${encodeURI(downArrow('rgba(0,0,0,0.5)'))}");
            background-size: 10px 5px;
            background-position: calc(100% - 16px) 25px;
            background-repeat: no-repeat;
            height: 56px;
            margin-right: 32px;
          }

          #inner:enabled {
            cursor: pointer;
          }

          #inner:disabled {
            background-image: url("data:image/svg+xml;charset=UTF-8,${encodeURI(downArrow('rgba(0,0,0,0.3)'))}");
          }

          #inner:focus {
            background-image: url("data:image/svg+xml;charset=UTF-8,${encodeURI(upArrow('rgba(0,0,0,0.5)'))}");
            background-position: calc(100% - 15px) 24px;
          }

          </style>

      `
    );

  }
}

export default TpSelectNativeBase;
